import React from 'react';
import 'firebase/firestore';
import Card from './Card';
import useFetchProdutos from './useFetchProdutos';
import Head from '../Head';
import logoCarregando from '../../Assets/logocantinho.png';
import BtnWhatsapp from '../BtnWhatsapp';

const Bolos = () => {
  const { bolos, carregando, error } = useFetchProdutos();

  if (bolos === null) return null;
  if (error) return <p>{error}</p>;
  if (carregando > 0) return <img src={logoCarregando} alt="logo cantinho" />;

  return (
    <>
      <BtnWhatsapp />
      <Head
        title="Cantinho d' Bolos | Bolos"
        description="Esses São nossos produtos."
      />
      {bolos.map((item) => (
        <Card
          key={item.id}
          id={item.id}
          img={item.foto}
          nome={item.nome}
          precoG={item.precoG}
          precoM={item.precoM}
          precoP={item.precoP}
          tipo={item.tipo}
          usuario={item.usuario}
          visualizacoes={item.visualizacoes}
          descricao={item.descricao}
        />
      ))}
    </>
  );
};

export default Bolos;
